"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductAliasErrorMessage = exports.ProductAliasResponse = void 0;
class ProductAliasResponse {
    constructor(data, error) {
        this.data = data;
        this.error = error;
    }
}
exports.ProductAliasResponse = ProductAliasResponse;
var ProductAliasErrorMessage;
(function (ProductAliasErrorMessage) {
    ProductAliasErrorMessage["NOT_FOUND_CHANNEL_PRODUCT_ID"] = "Requires parameter channelProductId";
    ProductAliasErrorMessage["NOT_FOUND_SLS_UUID"] = "Requires parameter sellerListingSolutionUUID";
    ProductAliasErrorMessage["NOT_FOUND_SELLER_ID"] = "Requires parameter sellerId";
    ProductAliasErrorMessage["NOT_FOUND_CHANNEL_ID"] = "Requires parameter channelId";
})(ProductAliasErrorMessage = exports.ProductAliasErrorMessage || (exports.ProductAliasErrorMessage = {}));
//# sourceMappingURL=ProductAliasResponse.js.map